import React, { Component } from 'react'
import ProfilesDetail from "../../components/ProfilesDetail"

export default class ProfilesDetailPage extends Component {
    render() {
      return (
        <div className="content-container">
            <ProfilesDetail {...this.props}/>
        </div>
      );
    }
}